<script setup lang="ts">
import { computed } from "vue";
import { useTheme } from "vuetify";

import { useSnackbarStore } from "@/stores/snackbarStore.ts";

import type { SnackbarProps } from "@/types/components/ui/snackbar.type.ts";

const snackbar = useSnackbarStore();
const theme = useTheme();

const snackbarProps = computed<SnackbarProps>(() => {
  const color: string = theme.current.value.colors[snackbar.color] as string;

  function lightenColor(hex: string, percent = 0.88) {
    let red = parseInt(hex.slice(1, 3), 16);
    let green = parseInt(hex.slice(3, 5), 16);
    let blue = parseInt(hex.slice(5, 7), 16);

    red = Math.min(255, red + Math.round((255 - red) * percent));
    green = Math.min(255, green + Math.round((255 - green) * percent));
    blue = Math.min(255, blue + Math.round((255 - blue) * percent));

    return `rgb(${red}, ${green}, ${blue})`;
  }

  let icon: string = "mdi-";

  switch (snackbar.color) {
    case "success":
      icon += "check-circle";
      break;
    case "warning":
      icon += "alert";
      break;
    case "error":
      icon += "alert-circle";
      break;
    default:
      icon += "alert";
  }

  return {
    backgroundColor: `${lightenColor(color)}`,
    color: `text-${snackbar.color}`,
    icon,
  };
});
</script>

<template>
  <v-snackbar
    v-model="snackbar.visible"
    :color="snackbarProps.backgroundColor"
    variant="flat"
    location="top right"
    :content-class="snackbarProps.color"
  >
    <div class="d-flex align-center">
      <v-icon class="mr-3" :icon="snackbarProps.icon" />
      <p>{{ snackbar.text }}</p>
    </div>
  </v-snackbar>
</template>
